const style = {
	//slidesToShow: 4, // doesnt work with variable width
	slidesToScroll: 2,
	arrows: true,
	// https://stackoverflow.com/questions/59979306/change-slick-slider-arrow-position
	// prevArrow: $(".slick-arrow-prev"),
	// nextArrow: $(".slick-arrow-next")
	// focusOnSelect: true,
	// lazyLoad: 'progressive' (or ondemand)
	variableWidth: true,
	width: 100,
	infinite: false,
	draggable: true,
	responsive: [
		{
			breakpoint: 1024,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 3,
				infinite: true,
				dots: true,
			},
		},
		{
			breakpoint: 960,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 2,
			},
		},
		{
			breakpoint: 640,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
			},
		},
	],
};

export default style;
